import React from "react";

const HelpingBusinesses = () => {
  return (
    <section className="py-12 px-6 md:px-16 xl:max-w-7xl mx-auto">
      {/* Heading */}
      <div className="text-center mb-12">
        <h5 className="text-sm uppercase text-gray-500 mb-2">
          Platform Features
        </h5>
        <h2 className="text-xl md:text-4xl font-bold">
          Explore The Features <br className="hidden md:block" />
          That Fuel Your Success
        </h2>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-12 gap-8">
        {/* Centralised Campaign Management */}
        <div className="col-span-12 md:col-span-8 bg-[#FFF5DD]  rounded-lg shadow-sm">
          <h3 className="pt-6 pl-6 text-lg font-semibold mb-4">
            Centralised Campaign Management
          </h3>
          <p className="pl-6 text-sm text-gray-600 mb-6">
            Streamline your marketing efforts with a single platform to track &
            execute your retail branding campaigns
          </p>
          <div>
            <div className="flex justify-end">
              <img
                src="\assests\images\LandingPage\campaign1.webp"
                alt="Centralised Campaign Management"
                className="rounded-lg "
              />
            </div>
          </div>
        </div>

        {/* Role Based Permissions */}
        <div className="col-span-12 md:col-span-4 bg-[#F5F2FF] pt-6 pl-6 pb-6 rounded-lg shadow-sm">
          <h3 className="text-lg font-semibold mb-4">Role Based Permissions</h3>
          <p className="text-sm text-gray-600 mb-6">
            Ensure secure and efficient access by assigning specific roles and
            permissions. Customize user access levels to align with their
            responsibilities
          </p>
          <div className="flex justify-end">
            <img
              src="\assests\images\LandingPage\team1.webp"
              alt="Role Based Permissions"
            />
          </div>
        </div>

        {/* Dedicated KAM */}
        <div className="col-span-12 md:col-span-4 bg-[#EAF8F4] pt-6 pl-6 pb-6 rounded-lg shadow-sm">
          <h3 className="text-lg font-semibold mb-4">Get a Dedicated KAM</h3>
          <p className="text-sm text-gray-600 mb-6">
            Get personalized support with a dedicated key account manager.
            They’ll understand your business needs and provide tailored
            solutions
          </p>
          <div className="flex justify-end">
            <img
              src="\assests\images\LandingPage\KAM1.webp"
              alt="Get a Dedicated KAM"
            />
          </div>
        </div>

        {/* Comprehensive Reporting */}

        <div className="col-span-12 md:col-span-8 bg-[#FFEAF5] pt-6 pl-6 pr-6 rounded-lg shadow-sm">
          <h3 className="text-lg font-semibold mb-4">
            Comprehensive Reporting
          </h3>
          <p className="text-sm text-gray-600 mb-6">
            Gain valuable insights with detailed reports on performance, trends,
            and metrics. Make informed decisions with real-time data
          </p>
          <div className="flex justify-center">
            <img
              src="\assests\images\LandingPage\reporting1.webp"
              alt="Comprehensive Reporting"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpingBusinesses;
